var cov_21otbgekd9 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/hoc/moveable.tsx",
      hash = "7c535336c8bffa7ff80741253841a68d6cc54bf0",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/hoc/moveable.tsx",
    statementMap: {
      "0": {
        start: {
          line: 9,
          column: 18
        },
        end: {
          line: 9,
          column: 20
        }
      },
      "1": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 123,
          column: 5
        }
      },
      "2": {
        start: {
          line: 35,
          column: 8
        },
        end: {
          line: 35,
          column: 20
        }
      },
      "3": {
        start: {
          line: 36,
          column: 8
        },
        end: {
          line: 40,
          column: 9
        }
      },
      "4": {
        start: {
          line: 42,
          column: 8
        },
        end: {
          line: 42,
          column: 38
        }
      },
      "5": {
        start: {
          line: 43,
          column: 8
        },
        end: {
          line: 43,
          column: 62
        }
      },
      "6": {
        start: {
          line: 44,
          column: 8
        },
        end: {
          line: 44,
          column: 62
        }
      },
      "7": {
        start: {
          line: 45,
          column: 8
        },
        end: {
          line: 45,
          column: 58
        }
      },
      "8": {
        start: {
          line: 49,
          column: 8
        },
        end: {
          line: 49,
          column: 24
        }
      },
      "9": {
        start: {
          line: 53,
          column: 8
        },
        end: {
          line: 55,
          column: 9
        }
      },
      "10": {
        start: {
          line: 54,
          column: 10
        },
        end: {
          line: 54,
          column: 72
        }
      },
      "11": {
        start: {
          line: 59,
          column: 25
        },
        end: {
          line: 59,
          column: 35
        }
      },
      "12": {
        start: {
          line: 60,
          column: 8
        },
        end: {
          line: 60,
          column: 46
        }
      },
      "13": {
        start: {
          line: 60,
          column: 30
        },
        end: {
          line: 60,
          column: 46
        }
      },
      "14": {
        start: {
          line: 61,
          column: 8
        },
        end: {
          line: 63,
          column: 9
        }
      },
      "15": {
        start: {
          line: 67,
          column: 8
        },
        end: {
          line: 67,
          column: 94
        }
      },
      "16": {
        start: {
          line: 68,
          column: 8
        },
        end: {
          line: 68,
          column: 28
        }
      },
      "17": {
        start: {
          line: 68,
          column: 22
        },
        end: {
          line: 68,
          column: 28
        }
      },
      "18": {
        start: {
          line: 69,
          column: 8
        },
        end: {
          line: 69,
          column: 67
        }
      },
      "19": {
        start: {
          line: 70,
          column: 8
        },
        end: {
          line: 70,
          column: 86
        }
      },
      "20": {
        start: {
          line: 74,
          column: 8
        },
        end: {
          line: 74,
          column: 46
        }
      },
      "21": {
        start: {
          line: 74,
          column: 40
        },
        end: {
          line: 74,
          column: 46
        }
      },
      "22": {
        start: {
          line: 75,
          column: 8
        },
        end: {
          line: 75,
          column: 74
        }
      },
      "23": {
        start: {
          line: 75,
          column: 68
        },
        end: {
          line: 75,
          column: 74
        }
      },
      "24": {
        start: {
          line: 76,
          column: 8
        },
        end: {
          line: 76,
          column: 68
        }
      },
      "25": {
        start: {
          line: 77,
          column: 8
        },
        end: {
          line: 77,
          column: 64
        }
      },
      "26": {
        start: {
          line: 78,
          column: 8
        },
        end: {
          line: 78,
          column: 67
        }
      },
      "27": {
        start: {
          line: 79,
          column: 8
        },
        end: {
          line: 81,
          column: 9
        }
      },
      "28": {
        start: {
          line: 80,
          column: 10
        },
        end: {
          line: 80,
          column: 66
        }
      },
      "29": {
        start: {
          line: 82,
          column: 8
        },
        end: {
          line: 82,
          column: 30
        }
      },
      "30": {
        start: {
          line: 83,
          column: 8
        },
        end: {
          line: 85,
          column: 10
        }
      },
      "31": {
        start: {
          line: 89,
          column: 8
        },
        end: {
          line: 101,
          column: 10
        }
      },
      "32": {
        start: {
          line: 90,
          column: 18
        },
        end: {
          line: 90,
          column: 38
        }
      },
      "33": {
        start: {
          line: 91,
          column: 18
        },
        end: {
          line: 91,
          column: 38
        }
      },
      "34": {
        start: {
          line: 92,
          column: 10
        },
        end: {
          line: 95,
          column: 11
        }
      },
      "35": {
        start: {
          line: 94,
          column: 12
        },
        end: {
          line: 94,
          column: 22
        }
      },
      "36": {
        start: {
          line: 96,
          column: 10
        },
        end: {
          line: 99,
          column: 11
        }
      },
      "37": {
        start: {
          line: 98,
          column: 12
        },
        end: {
          line: 98,
          column: 22
        }
      },
      "38": {
        start: {
          line: 100,
          column: 10
        },
        end: {
          line: 100,
          column: 25
        }
      },
      "39": {
        start: {
          line: 105,
          column: 8
        },
        end: {
          line: 105,
          column: 71
        }
      },
      "40": {
        start: {
          line: 106,
          column: 8
        },
        end: {
          line: 106,
          column: 67
        }
      },
      "41": {
        start: {
          line: 107,
          column: 8
        },
        end: {
          line: 107,
          column: 70
        }
      },
      "42": {
        start: {
          line: 108,
          column: 8
        },
        end: {
          line: 110,
          column: 10
        }
      },
      "43": {
        start: {
          line: 114,
          column: 40
        },
        end: {
          line: 114,
          column: 50
        }
      },
      "44": {
        start: {
          line: 115,
          column: 8
        },
        end: {
          line: 115,
          column: 57
        }
      },
      "45": {
        start: {
          line: 115,
          column: 23
        },
        end: {
          line: 115,
          column: 57
        }
      },
      "46": {
        start: {
          line: 116,
          column: 19
        },
        end: {
          line: 116,
          column: 71
        }
      },
      "47": {
        start: {
          line: 117,
          column: 19
        },
        end: {
          line: 120,
          column: 9
        }
      },
      "48": {
        start: {
          line: 121,
          column: 8
        },
        end: {
          line: 121,
          column: 68
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 22,
            column: 3
          },
          end: {
            line: 22,
            column: 4
          }
        },
        loc: {
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 123,
            column: 5
          }
        },
        line: 23
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 34,
            column: 6
          },
          end: {
            line: 34,
            column: 7
          }
        },
        loc: {
          start: {
            line: 34,
            column: 28
          },
          end: {
            line: 46,
            column: 7
          }
        },
        line: 34
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 48,
            column: 6
          },
          end: {
            line: 48,
            column: 7
          }
        },
        loc: {
          start: {
            line: 48,
            column: 26
          },
          end: {
            line: 50,
            column: 7
          }
        },
        line: 48
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 52,
            column: 6
          },
          end: {
            line: 52,
            column: 7
          }
        },
        loc: {
          start: {
            line: 52,
            column: 29
          },
          end: {
            line: 56,
            column: 7
          }
        },
        line: 52
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 58,
            column: 6
          },
          end: {
            line: 58,
            column: 7
          }
        },
        loc: {
          start: {
            line: 58,
            column: 17
          },
          end: {
            line: 64,
            column: 7
          }
        },
        line: 58
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 66,
            column: 6
          },
          end: {
            line: 66,
            column: 7
          }
        },
        loc: {
          start: {
            line: 66,
            column: 18
          },
          end: {
            line: 71,
            column: 7
          }
        },
        line: 66
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 73,
            column: 6
          },
          end: {
            line: 73,
            column: 7
          }
        },
        loc: {
          start: {
            line: 73,
            column: 37
          },
          end: {
            line: 86,
            column: 7
          }
        },
        line: 73
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 88,
            column: 6
          },
          end: {
            line: 88,
            column: 7
          }
        },
        loc: {
          start: {
            line: 88,
            column: 37
          },
          end: {
            line: 102,
            column: 7
          }
        },
        line: 88
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 89,
            column: 22
          },
          end: {
            line: 89,
            column: 23
          }
        },
        loc: {
          start: {
            line: 89,
            column: 30
          },
          end: {
            line: 101,
            column: 9
          }
        },
        line: 89
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 104,
            column: 6
          },
          end: {
            line: 104,
            column: 7
          }
        },
        loc: {
          start: {
            line: 104,
            column: 22
          },
          end: {
            line: 111,
            column: 7
          }
        },
        line: 104
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 113,
            column: 6
          },
          end: {
            line: 113,
            column: 7
          }
        },
        loc: {
          start: {
            line: 113,
            column: 15
          },
          end: {
            line: 122,
            column: 7
          }
        },
        line: 113
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 53,
            column: 8
          },
          end: {
            line: 55,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 53,
            column: 8
          },
          end: {
            line: 55,
            column: 9
          }
        }, {
          start: {
            line: 53,
            column: 8
          },
          end: {
            line: 55,
            column: 9
          }
        }],
        line: 53
      },
      "1": {
        loc: {
          start: {
            line: 60,
            column: 8
          },
          end: {
            line: 60,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 60,
            column: 8
          },
          end: {
            line: 60,
            column: 46
          }
        }, {
          start: {
            line: 60,
            column: 8
          },
          end: {
            line: 60,
            column: 46
          }
        }],
        line: 60
      },
      "2": {
        loc: {
          start: {
            line: 68,
            column: 8
          },
          end: {
            line: 68,
            column: 28
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 68,
            column: 8
          },
          end: {
            line: 68,
            column: 28
          }
        }, {
          start: {
            line: 68,
            column: 8
          },
          end: {
            line: 68,
            column: 28
          }
        }],
        line: 68
      },
      "3": {
        loc: {
          start: {
            line: 70,
            column: 25
          },
          end: {
            line: 70,
            column: 86
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 70,
            column: 35
          },
          end: {
            line: 70,
            column: 76
          }
        }, {
          start: {
            line: 70,
            column: 79
          },
          end: {
            line: 70,
            column: 86
          }
        }],
        line: 70
      },
      "4": {
        loc: {
          start: {
            line: 70,
            column: 35
          },
          end: {
            line: 70,
            column: 76
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 70,
            column: 35
          },
          end: {
            line: 70,
            column: 65
          }
        }, {
          start: {
            line: 70,
            column: 69
          },
          end: {
            line: 70,
            column: 76
          }
        }],
        line: 70
      },
      "5": {
        loc: {
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 74,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 74,
            column: 46
          }
        }, {
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 74,
            column: 46
          }
        }],
        line: 74
      },
      "6": {
        loc: {
          start: {
            line: 74,
            column: 12
          },
          end: {
            line: 74,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 74,
            column: 12
          },
          end: {
            line: 74,
            column: 26
          }
        }, {
          start: {
            line: 74,
            column: 30
          },
          end: {
            line: 74,
            column: 38
          }
        }],
        line: 74
      },
      "7": {
        loc: {
          start: {
            line: 75,
            column: 8
          },
          end: {
            line: 75,
            column: 74
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 75,
            column: 8
          },
          end: {
            line: 75,
            column: 74
          }
        }, {
          start: {
            line: 75,
            column: 8
          },
          end: {
            line: 75,
            column: 74
          }
        }],
        line: 75
      },
      "8": {
        loc: {
          start: {
            line: 75,
            column: 12
          },
          end: {
            line: 75,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 75,
            column: 12
          },
          end: {
            line: 75,
            column: 19
          }
        }, {
          start: {
            line: 75,
            column: 23
          },
          end: {
            line: 75,
            column: 66
          }
        }],
        line: 75
      },
      "9": {
        loc: {
          start: {
            line: 79,
            column: 8
          },
          end: {
            line: 81,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 79,
            column: 8
          },
          end: {
            line: 81,
            column: 9
          }
        }, {
          start: {
            line: 79,
            column: 8
          },
          end: {
            line: 81,
            column: 9
          }
        }],
        line: 79
      },
      "10": {
        loc: {
          start: {
            line: 92,
            column: 10
          },
          end: {
            line: 95,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 92,
            column: 10
          },
          end: {
            line: 95,
            column: 11
          }
        }, {
          start: {
            line: 92,
            column: 10
          },
          end: {
            line: 95,
            column: 11
          }
        }],
        line: 92
      },
      "11": {
        loc: {
          start: {
            line: 92,
            column: 14
          },
          end: {
            line: 92,
            column: 109
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 92,
            column: 14
          },
          end: {
            line: 92,
            column: 52
          }
        }, {
          start: {
            line: 92,
            column: 56
          },
          end: {
            line: 92,
            column: 109
          }
        }],
        line: 92
      },
      "12": {
        loc: {
          start: {
            line: 96,
            column: 10
          },
          end: {
            line: 99,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 96,
            column: 10
          },
          end: {
            line: 99,
            column: 11
          }
        }, {
          start: {
            line: 96,
            column: 10
          },
          end: {
            line: 99,
            column: 11
          }
        }],
        line: 96
      },
      "13": {
        loc: {
          start: {
            line: 96,
            column: 14
          },
          end: {
            line: 96,
            column: 110
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 96,
            column: 14
          },
          end: {
            line: 96,
            column: 53
          }
        }, {
          start: {
            line: 96,
            column: 57
          },
          end: {
            line: 96,
            column: 110
          }
        }],
        line: 96
      },
      "14": {
        loc: {
          start: {
            line: 115,
            column: 8
          },
          end: {
            line: 115,
            column: 57
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 115,
            column: 8
          },
          end: {
            line: 115,
            column: 57
          }
        }, {
          start: {
            line: 115,
            column: 8
          },
          end: {
            line: 115,
            column: 57
          }
        }],
        line: 115
      },
      "15": {
        loc: {
          start: {
            line: 119,
            column: 47
          },
          end: {
            line: 119,
            column: 78
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 119,
            column: 47
          },
          end: {
            line: 119,
            column: 65
          }
        }, {
          start: {
            line: 119,
            column: 69
          },
          end: {
            line: 119,
            column: 78
          }
        }],
        line: 119
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/hoc/moveable.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import { docSize } from '../utils/dom/document';
import { moveableClass } from './styles';
import { getUidStr } from '../utils/uid';
import { curry } from '../utils/func';
var DIS_LIMIT = (cov_21otbgekd9.s[0]++, 50);
export default curry(function (handler, Origin) {
  var _temp;

  cov_21otbgekd9.f[0]++;
  cov_21otbgekd9.s[1]++;
  return _temp =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(Moveable, _React$Component);

    var _super = _createSuper2(Moveable);

    function Moveable(props) {
      var _this;

      _classCallCheck(this, Moveable);

      cov_21otbgekd9.f[1]++;
      cov_21otbgekd9.s[2]++;
      _this = _super.call(this, props);
      _this.moveabledId = void 0;
      _this.el = void 0;
      _this.handlerEl = void 0;
      _this.hasDragged = void 0;
      _this.handlerPos = void 0;
      cov_21otbgekd9.s[3]++;
      _this.state = {
        x: 0,
        y: 0,
        draging: false
      };
      cov_21otbgekd9.s[4]++;
      _this.moveabledId = getUidStr();
      cov_21otbgekd9.s[5]++;
      _this.handleMouseDown = _this.handleMouseDown.bind(_assertThisInitialized(_this));
      cov_21otbgekd9.s[6]++;
      _this.handleMouseMove = _this.handleMouseMove.bind(_assertThisInitialized(_this));
      cov_21otbgekd9.s[7]++;
      _this.handleMouseUp = _this.handleMouseUp.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(Moveable, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        cov_21otbgekd9.f[2]++;
        cov_21otbgekd9.s[8]++;
        this.bindEvent();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        cov_21otbgekd9.f[3]++;
        cov_21otbgekd9.s[9]++;

        if (this.el) {
          cov_21otbgekd9.b[0][0]++;
          cov_21otbgekd9.s[10]++;
          this.el.removeEventListener('mousedown', this.handleMouseDown);
        } else {
          cov_21otbgekd9.b[0][1]++;
        }
      }
    }, {
      key: "getStyle",
      value: function getStyle() {
        cov_21otbgekd9.f[4]++;

        var _ref = (cov_21otbgekd9.s[11]++, this.state),
            x = _ref.x,
            y = _ref.y;

        cov_21otbgekd9.s[12]++;

        if (!this.hasDragged) {
          cov_21otbgekd9.b[1][0]++;
          cov_21otbgekd9.s[13]++;
          return undefined;
        } else {
          cov_21otbgekd9.b[1][1]++;
        }

        cov_21otbgekd9.s[14]++;
        return {
          transform: "translate(".concat(x, "px, ").concat(y, "px)")
        };
      }
    }, {
      key: "bindEvent",
      value: function bindEvent() {
        cov_21otbgekd9.f[5]++;
        cov_21otbgekd9.s[15]++;
        this.el = document.querySelector(".".concat(moveableClass(this.moveabledId)));
        cov_21otbgekd9.s[16]++;

        if (!this.el) {
          cov_21otbgekd9.b[2][0]++;
          cov_21otbgekd9.s[17]++;
          return;
        } else {
          cov_21otbgekd9.b[2][1]++;
        }

        cov_21otbgekd9.s[18]++;
        this.el.addEventListener('mousedown', this.handleMouseDown);
        cov_21otbgekd9.s[19]++;
        this.handlerEl = handler ? (cov_21otbgekd9.b[3][0]++, (cov_21otbgekd9.b[4][0]++, this.el.querySelector(handler)) || (cov_21otbgekd9.b[4][1]++, this.el)) : (cov_21otbgekd9.b[3][1]++, this.el);
      }
    }, {
      key: "handleMouseDown",
      value: function handleMouseDown(e) {
        cov_21otbgekd9.f[6]++;
        cov_21otbgekd9.s[20]++;

        if ((cov_21otbgekd9.b[6][0]++, e.button !== 0) || (cov_21otbgekd9.b[6][1]++, !this.el)) {
          cov_21otbgekd9.b[5][0]++;
          cov_21otbgekd9.s[21]++;
          return;
        } else {
          cov_21otbgekd9.b[5][1]++;
        }

        cov_21otbgekd9.s[22]++;

        if ((cov_21otbgekd9.b[8][0]++, handler) && (cov_21otbgekd9.b[8][1]++, !e.target.matches(handler))) {
          cov_21otbgekd9.b[7][0]++;
          cov_21otbgekd9.s[23]++;
          return;
        } else {
          cov_21otbgekd9.b[7][1]++;
        }

        cov_21otbgekd9.s[24]++;
        document.addEventListener('mousemove', this.handleMouseMove);
        cov_21otbgekd9.s[25]++;
        document.addEventListener('mouseup', this.handleMouseUp);
        cov_21otbgekd9.s[26]++;
        document.addEventListener('mouseleave', this.handleMouseUp);
        cov_21otbgekd9.s[27]++;

        if (!this.handlerPos) {
          cov_21otbgekd9.b[9][0]++;
          cov_21otbgekd9.s[28]++;
          this.handlerPos = this.handlerEl.getBoundingClientRect();
        } else {
          cov_21otbgekd9.b[9][1]++;
        }

        cov_21otbgekd9.s[29]++;
        this.hasDragged = true;
        cov_21otbgekd9.s[30]++;
        this.setState({
          draging: true
        });
      }
    }, {
      key: "handleMouseMove",
      value: function handleMouseMove(e) {
        var _this2 = this;

        cov_21otbgekd9.f[7]++;
        cov_21otbgekd9.s[31]++;
        this.setState(function (prev) {
          cov_21otbgekd9.f[8]++;
          var x = (cov_21otbgekd9.s[32]++, prev.x + e.movementX);
          var y = (cov_21otbgekd9.s[33]++, prev.y + e.movementY);
          cov_21otbgekd9.s[34]++;

          if ((cov_21otbgekd9.b[11][0]++, _this2.handlerPos.right + x < DIS_LIMIT) || (cov_21otbgekd9.b[11][1]++, _this2.handlerPos.left + x > docSize.width - DIS_LIMIT)) {
            cov_21otbgekd9.b[10][0]++;
            cov_21otbgekd9.s[35]++;
            // eslint-disable-next-line prefer-destructuring
            x = prev.x;
          } else {
            cov_21otbgekd9.b[10][1]++;
          }

          cov_21otbgekd9.s[36]++;

          if ((cov_21otbgekd9.b[13][0]++, _this2.handlerPos.bottom + y < DIS_LIMIT) || (cov_21otbgekd9.b[13][1]++, _this2.handlerPos.top + y > docSize.height - DIS_LIMIT)) {
            cov_21otbgekd9.b[12][0]++;
            cov_21otbgekd9.s[37]++;
            // eslint-disable-next-line prefer-destructuring
            y = prev.y;
          } else {
            cov_21otbgekd9.b[12][1]++;
          }

          cov_21otbgekd9.s[38]++;
          return {
            x: x,
            y: y
          };
        });
      }
    }, {
      key: "handleMouseUp",
      value: function handleMouseUp() {
        cov_21otbgekd9.f[9]++;
        cov_21otbgekd9.s[39]++;
        document.removeEventListener('mousemove', this.handleMouseMove);
        cov_21otbgekd9.s[40]++;
        document.removeEventListener('mouseup', this.handleMouseUp);
        cov_21otbgekd9.s[41]++;
        document.removeEventListener('mouseleave', this.handleMouseUp);
        cov_21otbgekd9.s[42]++;
        this.setState({
          draging: false
        });
      }
    }, {
      key: "render",
      value: function render() {
        cov_21otbgekd9.f[10]++;

        var _ref2 = (cov_21otbgekd9.s[43]++, this.props),
            moveable = _ref2.moveable,
            others = _objectWithoutProperties(_ref2, ["moveable"]);

        cov_21otbgekd9.s[44]++;

        if (!moveable) {
          cov_21otbgekd9.b[14][0]++;
          cov_21otbgekd9.s[45]++;
          return (
            /*#__PURE__*/
            React.createElement(Origin, Object.assign({}, others, {
              __self: this,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 115,
                columnNumber: 31
              }
            }))
          );
        } else {
          cov_21otbgekd9.b[14][1]++;
        }

        var ms = (cov_21otbgekd9.s[46]++, Object.assign({}, this.props.style, this.getStyle()));
        var mc = (cov_21otbgekd9.s[47]++, classnames(this.props.className, moveableClass('_', this.moveabledId, (cov_21otbgekd9.b[15][0]++, this.state.draging) && (cov_21otbgekd9.b[15][1]++, 'draging'))));
        cov_21otbgekd9.s[48]++;
        return (
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, others, {
            style: ms,
            className: mc,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 121,
              columnNumber: 16
            }
          }))
        );
      }
    }]);

    return Moveable;
  }(React.Component), _temp;
});